export default __webpack_public_path__ + "static/media/doc3.c64020f9.png";